import { BookmarkAction, ActionNames } from '../actions/BookmarkAction';
import { findIndex } from '../../../../../common/src/ts/utils';
import { BookmarkInfo } from '../../../../../common/src/ts/types/bookmark';

export type BookmarksState = ReadonlyArray<BookmarkInfo>;

export function bookmarkReducer(
  state: BookmarksState,
  action: BookmarkAction,
): BookmarksState {
  switch (action.type) {
    case ActionNames.APPEND_BOOKMARK: {
      return [...state, action.info];
    }
    case ActionNames.DELETE_BOOKMARK: {
      return state.filter(info => info.id !== action.id);
    }
    case ActionNames.MODIFY_BOOKMARK: {
      const index = findIndex(state, info => info.id === action.info.id);
      if (index < 0) {
        return state;
      }
      const bookmarks = state.slice();
      bookmarks[index] = { ...state[index], ...action.info };
      return bookmarks;
    }
    default:
      return state;
  }
}
